import React from 'react';
import Calendar2 from '../components/manager/Calendar2.jsx';

export default function CalendarStub() {
  return (
    <div className="p-4">
      <Calendar2 today={new Date()} storageNamespace="calendarPage" enableAssignWorkCta />
    </div>
  );
}
